import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { SilentRequest } from '@azure/msal-browser';
import { AppService } from 'src/app/app.service';
import { environment } from 'src/environments/environment.demo';

@Component({
  selector: 'app-my-bookmarks',
  templateUrl: './my-bookmarks.component.html',
  styleUrls: ['./my-bookmarks.component.scss']
})
export class MyBookmarksComponent implements OnInit {
  assetList: any
  image = "../../../assets/theme/img/bookmarkbanner.png"
  bannerTitle = "My Bookmarks";
  searchText: string;
  username: any;
  showLoadingSpinner = true;
  apiTimer: any;

  requesttoken: SilentRequest = {
     scopes: [environment.clientId + '/user.read'],
     account: undefined,
     // account: this.msalService.instance.getAllAccounts()[0]
   };
  constructor(private authService: MsalService,
    private _appService: AppService, private router: Router, private location: Location) { }

  ngOnInit(): void {
    this._appService.checkRefreshTokenValidity();
    this.requesttoken.account = this.authService.instance.getAllAccounts()[0]
        this.authService.acquireTokenSilent(this.requesttoken).subscribe(result => {
          // console.log("SilentToken response in MyBookmarksComponent...", result);
          sessionStorage.setItem('accessToken', result.accessToken);
          this._appService.jwtAuthorizationToken=result.accessToken;
          this.loadData();
        })
  }

  loadData(){
    this._appService.getUsername().subscribe(userdata => this.username = userdata);
    this.apiTimer = setInterval(()=>{
    this._appService.getAllAssets(3, null, this.username).subscribe(res => {
      if (Array.isArray(res)) {
        this.showLoadingSpinner = false;
        this.assetList = res
        if (!!res.length) {
          for (let i = 0; i < this.assetList.length; i++) {
            this.assetList[i]['User_BookMarked_Assets'] = 1
          }
        }
      }
      if(this.assetList){
        clearInterval(this.apiTimer);
      }
    })
  },2000);
  }

  onBoookmarkClick(data: any) {
    this._appService.addAssetBookmarked(data.isBookmarked, data.id, this.username).subscribe((res: any) => {
      this.assetList.splice(this.assetList.findIndex((item: any) => item.Asset_Id == data.id), 1)
    })
  }

  onBackClick() {
    this.location.back();
  }
}
